import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import React from "react";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

export const LSResultItemTitle = ({
  resource,
}: {
  resource: ResourceView | ResourceDWR;
}) => {
  if (!resource) {
    return null;
  }
  return (
    <Typography component="h3" variant="h6" flex={1}>
      <Link to={`/resource/${resource.id}`}>{resource.shortTitle}</Link>{" "}
      {resource?.publicationDate?.publicationDate && (
        <span>({resource?.publicationDate?.publicationDate})</span>
      )}
    </Typography>
  );
};
